import * as React from 'react';
import GridView1ListView from './views/grid_view_1/list/grid-view-1-list-view';
import GridView1DetailsView from './views/grid_view_1/details/grid-view-1-details-view';
import LaneView1ListView from './views/lane_view_1/list/lane-view-1-list-view';

interface ViewRegistry {
    list: Record<string, React.ComponentType<any>>;
    details: Record<string, React.ComponentType<any>>;
}

const registry: ViewRegistry = {
    list: {
        grid_view_1: GridView1ListView,
        lane_view_1: LaneView1ListView,
    },
    details: {
        grid_view_1: GridView1DetailsView,
        lane_view_1: GridView1DetailsView, // Reuse grid view details for lane view
    },
};

export const getListView = (viewId: string): React.ComponentType<any> | null => {
    return registry.list[viewId] || null;
};

export const getDetailsView = (viewId: string): React.ComponentType<any> | null => {
    return registry.details[viewId] || null;
};
